module.exports = __webpack_public_path__ + "media/packs/images/flags/CN-d1052ca51d98e9be0586df64f627276f.svg";